/* eslint-disable max-lines */
/* eslint-disable no-useless-escape */
import $ from 'jquery';

const customizer = {
    hasFlex: false,

    cleanCustomInput: function (el) {
        if (el.value.indexOf('”') > -1) {
            el.value = el.value.replace('”', '"');
        }

        if (el.value.indexOf('“') > -1) {
            el.value = el.value.replace('“', '"');
        }

        if (el.value.indexOf('’') > -1) {
            el.value = el.value.replace('’', "'");
        }

        if (el.value.indexOf('‘') > -1) {
            el.value = el.value.replace('‘', "'");
        }
    },

    openModal: function () {
        var modalOptions = {
            modal: true,
            resizable: false,
            autoOpen: true,
            width: 650,
            height: 650,
            title: 'Customization Options',
            modalClass: 'customizationModal',
            show: {effect: 'fade', duration: 800},
            hide: {effect: 'fade', duration: 500}
        };

        this.modal = smartPak.ui.modal($('#divCustomizationModal').get(0), modalOptions);
        this.updateTally();
    },

    closeModal: function () {
        if (this.modal) {
            this.modal.close();
        }
    },

    prepModalUI: function () {
        var $modal = $('#divCustomizationModal'),
            $container = $("<div id='customDialogContainer' />"),
            $tallyBlock = $(
                "<div id='tally'><div id='tallyBase'><div class='lineItem'>Item Cost: </div><div class='tallyCost'></div></div><div id='tallyCust'><div class='lineItem'>Customizations: </div><div class='tallyCost'></div></div> <div id='tallyTotal'><div class='lineItem'>Total: </div><div class='tallyCost'></div></div> </div>"
            ),
            prodData = this.pcVM,
            priceVal = this.pcVM.selectedPrice().current(),
            webPrice = priceVal.slice(priceVal.lastIndexOf('$'), priceVal.lastIndexOf('.') + 3);

        if ($modal.find('#customDialogContainer').length < 1) {
            $modal.append(
                "<div class='magBarHead'><h3 class='headItem prodName'>" +
                    prodData.name() +
                    "</h3><div class='headItem prodCost'>" +
                    webPrice +
                    '</div></div>'
            );
            $modal.append($container);
            $container.append("<div id='custBody'></div>");
            $container.append($tallyBlock);
            $container.append(
                "<div class='buttonFoot'><button class='secondary button custCancel'>Cancel</button><button class='primary button custSave' disabled>Apply</button></div>"
            );
            this.initUI($container);
        }

        this.openModal();
    },
    appendDelayMessage: function ($container, delays) {
        const $msg = document.createElement('div');
        const messages = [];

        if (delays.embroidery > 0) {
            messages.push(`orders with Embroidery are taking about ${delays.embroidery} extra days to ship`);
        }

        if (delays.engraving > 0) {
            messages.push(`orders with Engraving are taking about ${delays.engraving} extra days to ship`);
        }

        $msg.id = 'm-customization-modal-msg';
        $msg.className = 'mbl alert phl';
        $msg.innerHTML = `All customized items are personalized in our Plymouth, MA facility. The complexity of the order, seasonal demand, and your delivery location may impact shipping times. Please note that ${messages.join(' and ')}.`;

        $container.append($msg);
    },
    initUI: function ($container) {
        this.bindCancel();

        if (!this.hasFlex) {
            this.showNoFlexMsg();
            return;
        }

        $.get(this.apiUrl + this.pcVM.id(), data => {
            const {EmbroideryDelay, EngravingDelay} = data.Content;
            this.buildPrefs(data.Content.Preferences);
            if (EmbroideryDelay || EngravingDelay) {
                this.appendDelayMessage($container, {
                    embroidery: EmbroideryDelay,
                    engraving: EngravingDelay
                });
            }
        });
        this.showCustLoader();
        this.bindSave();
    },

    showNoFlexMsg: function () {
        var $msg = $(
            "<div id='noFlexMsg'>Looks like the browser or operating system you're using doesn't support our Customization feature.  Updating your browser or operating system to the latest version may resolve the problem – or call our experts 24/7 at <b>800-461-8898</b>.<br>We're always happy to help!</div>"
        );
        $('#custBody').append($msg);
    },

    filterActive: function (data) {
        return $.grep(data, function (item) {
            return item.DefaultIsActive;
        });
    },

    showCustLoader: function () {
        $('#loadingMessage').clone().attr({style: '', id: 'custLoader'}).removeClass('jsHide').appendTo('#custBody');
    },

    removeCustLoader: function () {
        $('#custLoader').remove();
    },

    buildPrefs: function (preferences) {
        var choices = this.filterActive(preferences),
            $items = $(),
            limit = choices.length,
            $block = this.$optionBlock.clone(),
            $choices = $('.customRow', $block),
            i,
            $tempItem;

        for (i = 0; i < limit; i++) {
            $tempItem = $("<button class='primary button item' data-size='sm'></button>");
            $tempItem.text(choices[i].DisplayName).data({
                PreferenceId: choices[i].PreferenceId,
                index: i,
                priceDiff: choices[i].BasePrice,
                PreferenceName: choices[i].DisplayName,
                PreferenceTypeId: choices[i].PreferenceTypeId
            });
            $items = $items.add($tempItem);
        }

        $items.appendTo($choices);

        this.$editLink.find('a').attr('aria-label', 'Edit Customization Style');

        $('.customHead .rowTitle', $block).text('Customization Style').append(this.$editLink);
        $block.addClass('x1 rootOption').appendTo('#custBody');
        this.bindRootChoiceClick(choices);
        this.removeCustLoader();
    },

    bindRootChoiceClick: function (choices) {
        $('.rootOption').on('click', '.item', e => {
            var $clicked = $(e.currentTarget),
                selIndex = $clicked.data('index');

            if ($clicked.parents('.customChoice').data().PreferenceId !== $clicked.data('PreferenceId')) {
                this.resetUI();
            } else {
                return;
            }

            this.buildOptions(choices[selIndex].Options);
        });
    },

    buildOptions: function (dataSet) {
        var limit = dataSet.length,
            $blocks = $(),
            $choices,
            $editBtn,
            $block,
            i;

        // build each block
        for (i = 0; i < limit; i++) {
            $block = this.$optionBlock.clone();
            $editBtn = this.$editLink.clone();

            $editBtn.find('a').attr('aria-label', 'Edit ' + dataSet[i].DisplayName);

            $choices = $('.customRow', $block);
            $('.customHead .rowTitle', $block).text(dataSet[i].DisplayName).append($editBtn);
            $('.customRow .rowExplainer', $block).text(dataSet[i].CustomerInstructions || '');

            if (dataSet[i].OptionValues.length === 1 && dataSet[i].OptionValues[0].CharLimit > 0) {
                this.makeTextUI(dataSet[i], $choices, $block);
            } else {
                this.makeChoiceButtons(dataSet[i], $choices, $block);
            }

            this.updateOptionOrder($('.customRow .item', $block));

            $blocks = $blocks.add($block);
        }

        $blocks.appendTo('#custBody');
        this.bindOptionSelectActions();
        this.handleSingleOption();
    },

    updateOptionOrder: function ($custRow) {
        var $noneItem = $(this.findNoneChoice($custRow)[0]) || null;
        $noneItem.insertAfter($custRow.last());
    },

    findNoneChoice: function ($items) {
        return $.grep($items, function (val) {
            return $(val).data('optionValue') === 'None';
        });
    },

    handleSingleOption: function () {
        $('.customRow')
            .not('.rootOption .customRow')
            .each(function () {
                // eslint-disable-next-line no-invalid-this
                var items = $(this).children('.item');
                if (items.length === 1) {
                    items.trigger('click');
                }
            });
    },

    makeTextUI: function (dataSet, $choices) {
        dataSet.OptionValues[0].OptionName = dataSet.DisplayName;
        $choices.append(this.handleTextField(dataSet.OptionValues));
    },

    makeChoiceButtons: function (dataSet, $choices, $block) {
        var $items = $(),
            $tempItem,
            j = 0;
        for (; j < dataSet.OptionValues.length; j++) {
            dataSet.OptionValues[j].OptionName = dataSet.DisplayName;
            this.buildChoice($block, dataSet, j);
            $tempItem = this.buildChoice($block, dataSet, j);
            $items = $items.add($tempItem);
        }
        $items.appendTo($choices);
        if (dataSet.IsGraphicsList) {
            this.getBarnLogos($choices);
        }
        $choices.addClass(this.setOptionSizing(j, $tempItem));
        if (dataSet.OptionValues.length < 1) {
            $choices.parent('.customChoice').addClass('emptyCustomChoice').removeClass('customChoice');
        }
    },

    buildChoice: function ($block, dataSet, index) {
        var $tempItem = $("<button class='item'></button>"),
            parens = /\(([^\)]+)\)/g;

        if (this.isImageSet(dataSet.OptionValues)) {
            this.createImageSet($block, $tempItem, dataSet, index);
        }

        if (dataSet.OptionValues[index].DisplayName === 'Yes' || dataSet.OptionValues[index].DisplayName === 'No') {
            $tempItem.addClass('small');
        }

        $tempItem.append(
            '<span class="item-img-label">' + dataSet.OptionValues[index].DisplayName.replace(parens, '') + '</span>'
        );
        this.addItemData($tempItem, dataSet.OptionValues[index]);

        return $tempItem;
    },

    getBarnLogos: function ($choices) {
        $.get('/api/customization/GetCustomerCustomizationBarnLogo', data => {
            this.addBarnLogos(data.Content, $choices);
        });
    },

    addBarnLogos: function (dataSet, $choices) {
        var $tempDiv = $("<button class='item'></button>"),
            imgName,
            $firstItem = $choices.children('.item').first(),
            $firstItemData = $firstItem.data(),
            $tempItem,
            i;

        if (!dataSet || dataSet.length < 1) {
            return;
        }

        for (i = 0; i < dataSet.length; i++) {
            $tempItem = $tempDiv.clone();
            imgName = dataSet[i].DisplayName;
            $tempItem
                .addClass('graphicItem')
                .css('background-image', 'url(' + dataSet[i].LogoUrl + ')')
                .text(imgName);
            $tempItem.data({
                barnLogoId: dataSet[i].Id || null,
                optionValueId: dataSet[i].Id,
                optionValue: dataSet[i].InternalName,
                optionId: $firstItemData.optionID,
                optionName: $firstItemData.optionName,
                thumb: dataSet[i].LogoUrl
            });
            $tempItem.insertBefore($firstItem);
        }
    },

    createImageSet: function ($block, $tempItem, dataSet, index) {
        var imgURL = encodeURI(this.thumbPath + $.trim(dataSet.OptionValues[index].Image) + '?width=135'),
            altText;
        $block.addClass('imageSet');
        if (
            dataSet.OptionValues[index].Image === 'SPthcLetSmartPakChoose.jpg' ||
            dataSet.OptionValues[index].Image === 'noneselected.jpg' ||
            !dataSet.OptionValues[index].Image
        ) {
            imgURL = '';
        }
        if (imgURL) {
            altText = dataSet.OptionValues[index].DisplayName + ' ' + dataSet.OptionValues[index].OptionName;
            $(
                '<img class="item-img" src="https://www.smartpakequine.com/' + imgURL + '" alt="' + altText + '" />'
            ).appendTo($tempItem);
        } else {
            $tempItem.addClass('noImg');
        }

        this.updateItemClass($tempItem, dataSet.OptionId);
        this.updateItemStyles($tempItem, dataSet.OptionId);
    },

    updateItemClass: function ($el, optionId) {
        if (this.isFontItem(optionId)) {
            $el.addClass('fontItem');
        }
        if (this.isGraphicItem(optionId)) {
            $el.addClass('graphicItem');
        }
        if (this.isMonogramItem(optionId)) {
            $el.addClass('monogramItem');
        }
    },

    updateItemStyles: function ($el, optionId) {
        var monoItem = this.isMonogramItem(optionId),
            specCss = this.isSpecificStyling(optionId);
        if (monoItem) {
            $el.css(monoItem);
        }
        if (specCss) {
            $el.css(specCss);
        }
    },

    handleTextField: function (dataSet) {
        var $textDiv = $('<div class="customTextFields" />'),
            rawData = dataSet[0].DisplayName,
            textMax,
            textLines;

        rawData = rawData.slice(rawData.lastIndexOf('(') + 1, rawData.lastIndexOf(')')).split(',');
        textLines = rawData[0];
        textMax = dataSet[0].CharLimit;
        $textDiv.append(this.buildTextFields(textLines, textMax));
        $textDiv.append(
            "<button class='primary button item textOK' data-size='sm'>OK</button><div class='maxChars'>" +
                this.buildMaxCharsMessage(textLines, textMax) +
                '</div>'
        );
        this.addItemData($textDiv.find('.textOK'), dataSet[0]);

        return $textDiv;
    },

    bindTextFieldChange: function () {
        $(document).on(
            'keyup',
            '.customTextField',
            function (e) {
                this.cleanCustomInput(e.target);
            }.bind(this)
        );
    },

    addItemData: function ($item, dataSet) {
        var opVal = $item.is('.textOK') ? [] : dataSet.DisplayName;

        $item.data({
            optionValueID: dataSet.OptionValueId,
            optionValue: opVal,
            optionID: dataSet.OptionId,
            optionName: dataSet.OptionName,
            barnLogoID: dataSet.BarnLogoId || null,
            thumb: dataSet.Image || '',
            priceDiff: dataSet.PriceDiff || 0
        });
    },

    buildTextFields: function (lines, max) {
        var fields =
                "<input title='Enter Your Custom Text' type='text' maxlength='" +
                max +
                "' class='customTextField' id='customText' />",
            i = 1;
        if (lines > 1) {
            for (; i < lines; i++) {
                fields +=
                    "<input title='Enter Your Custom Text - Line " +
                    (i + 1) +
                    "' type='text' maxlength='" +
                    max +
                    "' class='customTextField' id='customText" +
                    i +
                    1 +
                    "' />";
            }
        }
        return $(fields);
    },

    buildMaxCharsMessage: function (lines, textMax) {
        var msg = textMax + ' characters max';
        if (lines > 1) {
            msg += ' / line';
        }

        return msg;
    },

    setOptionSizing: function (optionCount, $item) {
        var xClass = 'x7',
            options = optionCount + 1;

        if (options < 9) {
            xClass = 'x4';
        }
        if (options < 7) {
            xClass = 'x2';
        }
        if (options === 4) {
            xClass = 'x4';
        }
        if ($item && $item.is('.fontItem, .monogramItem, .graphicItem')) {
            xClass = 'x4';
        }

        return xClass;
    },

    customizeNotificationRequired: function () {
        $('#divCustomizationMessage').addClass('notificationRequired');
    },

    // BUTTON STYLING:

    isImageSet: function (dataSet) {
        return (
            $.grep(dataSet, op => {
                return !!op.Image;
            }).length > 0
        );
    },

    isFontItem: function (optionID) {
        var fontItemIDs = [4, 5, 23, 28, 31, 36, 37, 71, 204, 234, 278];
        return $.inArray(optionID, fontItemIDs) > -1;
    },

    isMonogramItem: function (optionID) {
        var itemIDs = {
            1: {'background-size': '60%', 'background-position-y': '16px'},
            20: {'background-size': '60%', 'background-position-y': '16px'},
            231: {'background-size': '85%', 'background-position-y': '8px'},
            57: {'background-size': '100%', 'background-position-y': '-6px', 'color': '#FFF'}
        };

        // eslint-disable-next-line no-prototype-builtins
        if (itemIDs.hasOwnProperty(optionID)) {
            return itemIDs[optionID];
        }

        return null;
    },

    isGraphicItem: function (optionID) {
        var gfkItemIDs = [30, 73, 137, 223];
        return $.inArray(optionID, gfkItemIDs) > -1;
    },

    isSpecificStyling: function (optionID) {
        var itemIDs = {
            4: {'background-position-y': '-4%', 'background-color': '#fff'},
            28: {'background-color': '#fff'},
            6: {'background-position-y': '-3px', 'font-size': '0px'},
            23: {'background-position-y': '5px', 'background-color': '#fff', 'background-size': '75%'},
            57: {color: '#2c2c2c'},
            58: {'background-image': 'none'},
            71: {
                'background-size': 'cover',
                'background-position-y': '-5px',
                'background-color': '#2c2c2c',
                'color': '#fff',
                'font-size': '12px'
            },
            223: {'background-size': 'cover', 'background-position-y': '17px'}
        };

        // eslint-disable-next-line no-prototype-builtins
        if (itemIDs.hasOwnProperty(optionID)) {
            return itemIDs[optionID];
        }

        return null;
    },

    //OPTION SELECTION /DESELECTION:

    bindOptionSelect: function () {
        $('#customDialogContainer')
            .off()
            .on('click', '.item', e => {
                var $clicked = $(e.currentTarget),
                    $parent = $clicked.parents('.customChoice'),
                    optionData = $clicked.data();

                if ($parent.is('.rootOption')) {
                    $clicked.data('selectedLabel', $clicked.text());
                }

                if ($clicked.is('.textOK')) {
                    this.handleTextOK($clicked);
                    return;
                }

                this.handleOptionSelect(optionData, $parent);
            });
    },

    hasPunctuation: function (text) {
        var punc = /[^a-zA-Z\d\s]/g;
        return text.match(punc);
    },

    checkPunctuation: function ($fields) {
        var allTxt = '';
        $fields.each(function () {
            // eslint-disable-next-line no-invalid-this
            allTxt += $(this).val();
        });

        if (this.hasPunctuation(allTxt)) {
            this.warnPunctuation($fields);
        }
    },

    warnPunctuation: function ($txtFields) {
        var $row = $txtFields.parents('.customRow');
        $(
            '<div class="puncWarning" >We see you have punctuation in your text.<br>Be aware your customization will include all characters as submitted.</div>'
        ).insertBefore($row);
    },

    handleTextOK: function ($clicked) {
        var $fields = $clicked.siblings('.customTextField'),
            $parent = $clicked.parents('.customChoice'),
            fieldVals = [],
            displayText = "<div id='displayCustomText'>",
            textLine,
            data = $clicked.data();

        if (this.getTextFieldCharCount($fields) < 1) {
            return;
        }

        this.checkPunctuation($fields);

        $fields.each(function () {
            // eslint-disable-next-line no-invalid-this
            textLine = $(this).val();
            fieldVals.push(textLine);
            displayText += "<div class='displayTextLine'>" + textLine + '</div>';
        });
        displayText += '</div>';
        $(displayText).appendTo($('.rowSelection', $parent));

        data.optionValue = fieldVals;

        this.handleOptionSelect(data, $parent);
    },

    handleOptionSelect: function (data, $parentBlock) {
        var image = data.thumb,
            cost = data.priceDiff,
            $rowTitle,
            imagePath,
            parens = /\(([^\)]+)\)/g,
            selImg,
            imgAltText = '';

        $parentBlock.addClass('chosen');

        if (data.selectedLabel) {
            $('.rowSelection', $parentBlock).text(data.selectedLabel);
        }

        if (image) {
            if (!Array.isArray(data.optionValue) && data.optionValue && data.optionName) {
                imgAltText = data.optionValue + ' ' + data.optionName;
            }
            imagePath = image.indexOf('GetCustomizationBarnLogo') > 0 ? image : this.thumbPath + image;
            selImg = $(
                "<img class='selectedThumb' src='https://www.smartpakequine.com/" +
                    imagePath +
                    "' alt='" +
                    imgAltText +
                    "' />"
            ).on('error', function (e) {
                $(e.target).hide();
            });
            $('.rowSelection', $parentBlock).prepend(selImg);
        }
        if (!$.isArray(data.optionValue) && !$parentBlock.is('.rootOption')) {
            $rowTitle = $('.rowTitle', $parentBlock);
            $rowTitle.find('.optionValue').remove();
            $rowTitle.append("<div class='optionValue'>&rsaquo; " + data.optionValue.replace(parens, '') + '</div>');
        }

        $parentBlock.data(data);

        if ($parentBlock.data('optionID') === 274 && $parentBlock.data('optionValueID') === 63) {
            this.hideDependentOptions($parentBlock.data('optionID'));
        }

        this.updateTally(cost, $parentBlock);
        this.toggleSaveButton();
    },

    hideDependentOptions: function (optionid) {
        var optionIdMap = {274: ['275', '276', '277']},
            choice,
            $choice,
            i;

        for (i = 0; i < optionIdMap[optionid].length; i++) {
            choice = this.getChoiceById(optionIdMap[optionid][i]);
            $choice = $(choice[0]);
            $choice.find('.customTextField').val('0');
            $choice.find('.textOK').trigger('click');
        }
    },

    getChoiceById: function (id) {
        return $.grep($('.customChoice'), function (val) {
            return $(val).find('.item').data('optionID') == id;
        });
    },

    getTextFieldCharCount: function ($fields) {
        var txtlen = 0;

        $fields.each(function () {
            // eslint-disable-next-line no-invalid-this
            txtlen += $(this).val().trim().length;
        });

        return txtlen;
    },

    handleOptionEdit: function ($parentBlock) {
        $parentBlock.removeClass('chosen');
        $('.rowSelection', $parentBlock).empty();
        $('.puncWarning', $parentBlock).remove();
        this.toggleSaveButton();
    },

    cleanOutRestrictedCustomizationCharacters: function ($target) {
        var text = $target.val();
        text = text.replace(/[^A-Za-z0-9 _.,!"'/$@#%^&*()+=\[\]{};:?-]/gm, '');
        $target.val(text);
    },

    toggleSaveButton: function () {
        var $save = $('.custSave');
        if ($('.customChoice').length === $('.chosen').length) {
            $save.prop('disabled', false);
        } else {
            $save.prop('disabled', true);
        }
    },

    resetUI: function () {
        $('.customChoice').not('.rootOption').remove();
    },

    // BINDINGS:

    bindOptionSelectActions: function () {
        this.bindOptionSelect();
        this.bindOptionEdit();
        this.bindCharacterRestriction();
    },

    bindCharacterRestriction: function () {
        $('#customText').keyup(function (e) {
            e.preventDefault();
            customizer.cleanOutRestrictedCustomizationCharacters($(e.currentTarget));
        });
    },

    bindOptionEdit: function () {
        $('#customDialogContainer').on('click', '.customChoice.chosen', function (e) {
            e.preventDefault();
            // eslint-disable-next-line no-invalid-this
            customizer.handleOptionEdit($(this));
        });
    },

    rebindCustomizationStart: function () {
        var $link = $('#lnkCustomize');
        if ($link) {
            $link.off().on(
                'click',
                function (e) {
                    e.preventDefault();
                    this.prepModalUI();
                }.bind(this)
            );
        }
    },

    bindCustomReviewLinks: function () {
        $('.deleteCustomization').on(
            'click',
            function (e) {
                e.preventDefault();
                this.deleteCustomization();
            }.bind(this)
        );
        $('.editCustTable').on(
            'click',
            function (e) {
                e.preventDefault();
                this.openModal();
            }.bind(this)
        );
    },

    bindSave: function () {
        $('.buttonFoot').on(
            'click',
            '.custSave',
            function (e) {
                e.preventDefault();
                this.buildData();
            }.bind(this)
        );
    },

    bindCancel: function () {
        $('.custCancel').on(
            'click',
            function (e) {
                e.preventDefault();
                this.closeModal();
            }.bind(this)
        );
    },

    bindAndroidCharLimits: function () {
        // eslint-disable-next-line consistent-return
        $('#divCustomizationModal').on('input', '.customTextField', e => {
            var $target = $(e.currentTarget),
                limit = $target.attr('maxlength'),
                fieldVal = $target.val(),
                curChars = $target.val().length;

            if (curChars >= limit) {
                $target.val(fieldVal.slice(0, limit));
                e.preventDefault();
                return false;
            }
        });
    },

    // COST TALLY & DISPLAY

    updateTally: function (cost, $targetRow) {
        var $rowSelect = $('.rowSelection', $targetRow),
            per = $('#Quantity').val() > 1 ? '/ea' : '';
        if (cost > 0) {
            $rowSelect.find('.addCost').remove();
            $rowSelect.append("<div class='addCost'>+ $" + cost.toFixed(2) + '<span>' + per + '</span></div>');
            $('#tally').show();
        }

        if (this.pcVM.selectedProduct()) {
            $('#tallyBase .tallyCost').text($('.headItem.prodCost').text());
            $('#tallyBase').show();
        } else {
            $('#tallyBase').hide();
        }

        $('#tallyCust .tallyCost').text('+$' + this.getTallySum());
        $('#tallyTotal .tallyCost').text('$' + this.getTallyTotal().toFixed(2) + per);
        if (per) {
            $('#tallyBase, #tallyCust').css('padding-right', '23px');
        }
    },

    getTallySum: function () {
        var cost = 0,
            rawCost;

        $('.addCost').each(function () {
            // eslint-disable-next-line no-invalid-this
            rawCost = $(this).text();
            rawCost = rawCost.slice(rawCost.lastIndexOf('$') + 1, rawCost.lastIndexOf('.') + 3);

            cost += Number(rawCost);
        });

        cost = cost.toFixed(2);
        return cost;
    },

    getTallyTotal: function () {
        var base,
            cost,
            $tallyEl = $('#tallyBase .tallyCost'),
            $costEl = $('#tallyCust .tallyCost');

        base = Number($tallyEl.text().replace('$', '')) || 0;
        cost = Number($costEl.text().replace('+$', '')) || 0;

        return base + cost;
    },

    // DATA COLLECTION / HANDLING:

    buildData: function () {
        if ($('.custSave').prop('disabled')) {
            return;
        }

        var data = $('.rootOption.chosen').data(),
            tempData;

        delete data.index;
        delete data.selectedLabel;

        data.productClassId = this.pcVM.id();
        data.options = [];

        $('.chosen')
            .not('.rootOption')
            .each(function (index, current) {
                tempData = $(current).data();
                tempData.optionName = tempData.optionName.replace(/\(([^\)]+)\)/g, '');
                tempData.optionValue = Array.isArray(tempData.optionValue)
                    ? tempData.optionValue
                    : [tempData.optionValue];
                delete tempData.thumb;
                data.options.push(tempData);
            });

        this.displayCustomization(data);
        this.saveData(data);
    },

    saveData: function (data) {
        this.pcVM.customizationData(JSON.stringify(data));
        this.closeModal();
        $('#custAdded').addClass('show');
    },

    displayCustomization: function (data) {
        $('#custAdded').remove();

        var $custTable = $(
                "<table id='custTable'><tr><td colspan='2' class='border-row-btm' id='prefRow'>" +
                    data.PreferenceName +
                    "<a class='floatRight editCustTable' href='#''>edit</a></td></tr></table>"
            ),
            $custTableWrap = $("<div id='custTableWrap' class='custTableWrap'></div>"),
            $custAdded = $("<div id='custAdded' class='custAdded'></div>"),
            $custMsg = $('#divCustomizationMessage'),
            per = $('#Quantity').val() > 1 ? '/ea' : '',
            ops = data.options,
            limit = ops.length,
            i = 0,
            sum = +this.getTallySum(),
            parens = /\(([^\)]+)\)/g,
            $newRow,
            opName,
            cost;

        for (i; i < limit; i++) {
            opName = $.trim(ops[i].optionName.replace(parens, ''));
            $newRow = $(
                '<tr><td class="opName" >' +
                    opName +
                    ':</td><td class="opVal">' +
                    ops[i].optionValue.join('<br>') +
                    '</td></tr>'
            );
            $newRow.appendTo($custTable);
        }

        cost = sum > 0 ? '+ $' + sum.toFixed(2) : 'FREE';

        $('<tr><td class="opName" >Cost:</td><td class="opVal">' + cost + per + '</td></tr>').appendTo($custTable);
        $(
            '<tr><td></td><td></td></tr><tr id="linkRow"><td colspan="2" class="deleteLink"><a class="deleteCustomization alert" href="#">remove personalization</a></td></tr>'
        ).appendTo($custTable);
        $custMsg.find('#custBeginWrap').hide();
        $custTable.appendTo($custTableWrap);
        $('<div class="customize-title">Customization added:</div>').appendTo($custAdded);
        $custTableWrap.appendTo($custAdded);
        $custAdded.appendTo($custMsg);
        $custMsg.removeClass('notificationRequired');

        this.bindCustomReviewLinks();
    },

    deleteCustomization: function () {
        this.pcVM.customizationData(undefined);
        $('#divCustomizationModal').empty();
        $('#customDialogContainer #tally').hide();
        $('#custAdded').remove();
        $('#divCustomizationMessage #custBeginWrap').show();
        this.rebindCustomizationStart();
    },

    checkForFlex: function () {
        var el = document.getElementsByTagName('body');
        return (
            el[0].style.flexWrap !== undefined ||
            el[0].style.WebkitFlexWrap !== undefined ||
            el[0].style.msFlexWrap !== undefined
        );
    },

    initMobile: function () {
        if (this.isMobile) {
            $('body').addClass('isMobile');
            this.bindAndroidCharLimits();
        }
    },

    //initialize:
    init: function (viewModel) {
        (this.apiUrl = '/api/customization/GetCustomizationPreference/'),
            (this.$optionBlock = $(
                "<div class='customChoice'><div class='customHead'><h3 class='rowTitle'></h3><div class='rowSelection'><div class='addCost'></div></div></div><div class='customRow'><div class='rowExplainer'></div></div></div>"
            )),
            (this.$editLink = $('<span class="editOption">(<a href="#">edit</a>)</span>')),
            (this.thumbPath = '/images/custom/'),
            (this.isMobile = smartPak.page.isMobile());

        this.pcVM = viewModel;
        this.hasFlex = this.checkForFlex();
        this.rebindCustomizationStart();
        this.initMobile();
        this.bindTextFieldChange();

        return this;
    }
};

export default customizer;
